export default "__VITE_ASSET__B_bJbvD3__"